unit uAgenda;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, Vcl.StdCtrls,
  WEBLib.StdCtrls, Vcl.Controls, WEBLib.ExtCtrls, Vcl.Imaging.pngimage, WEBLib.Controls, WEBLib.Dialogs,
  WEBLib.SyntaxMemo, WEBLib.WebCtrls, Web, JS, libfilereader, WEBLib.Buttons,
  WEBLib.REST, WEBLib.Grids, WEBLib.DBCtrls;

type
  TReadFILES = class(TWebForm)
    Msg01: TWebMessageDlg;
    execAPIs: TWebHttpRequest;
    nRESP: TWebMemo;
    appcontent: TWebHTMLDiv;
    nARQ: TWebMemo;
    btnProcessar: TWebLinkLabel;
    UnMark: TWebLinkLabel;
    WebFilePicker1: TWebFilePicker;
    nCont: TWebLabel;
    WebDBResponsiveGrid1: TWebDBResponsiveGrid;
    //WebLabel10: TWebLabel;
    procedure WebFilePicker1Change(Sender: TObject);
    procedure WebFilePicker1GetFileAsText(Sender: TObject; AFileIndex: Integer;
      AText: string);
    procedure WebFormUnload(Sender: TObject);
    procedure WebSyntaxMemo1DragDrop(Sender, Source: TObject; X, Y: Integer);
    procedure WebPanel1DblClick(Sender: TObject);
    procedure btnProcessarClick(Sender: TObject);
    procedure UnMarkClick(Sender: TObject);
    procedure nARQDblClick(Sender: TObject);

  private
    fl: Boolean;
    fr: TWebFileReader;
    FFileName: string;
    procedure LoadFile;
  end;

var
  ReadFILES: TReadFILES;

implementation

{$R *.dfm}
uses uFrmMain;


procedure TReadFILES.btnProcessarClick(Sender: TObject);
var
  OKArqProd: boolean;
  zLinhas, zCont, zContPROD, zCampos, xFDstart, xFDend: integer;
  xProd, xProdOLD, xDesenho, xDESCR, xURL: string;
begin

    //A- Verifica se o arquivo é de Produtos e tem os dados corretamente-90
    OKArqProd   := true;
    for zLinhas := 0 to nARQ.Lines.Count-1 do
    begin

        //Se envontrar '^MCY' então não é etiqueta de Produtos
        if pos('^MCY', nARQ.Lines[zLinhas]) > 0 then
        begin
            OKArqProd   := false;
        end;

    end;

    //B- Cadastra a Data de inclusão dos Produtos e Etiquetas
    if OKArqProd = True then
    begin
        //http://localhost:8082/api/carga/nova_carga?iduser=1
        {
            "iduser": 47,    //IdPeça a Ficar
            "idpess": 606   //Ainda não usado 09/05/2025 ***********

            MastData.ExecuteQUERY.CommandText:= 'INSERT INTO ItensNF_UDs (IdProd, IdPeça, IdOF, QtdeUD, Cod128, DataMvto, OperadorUD, QtdeLote, LoteOF, Local_Entrega, Embalagem, Planta, Kanban, NumEmbal, Data_FAB, DataFAB, DataValidade, PesoBruto, DataLcto) Values ('
            + MirrIdConjunto.Text + ', '
            + Mirr100.Text + ', '
            + IdOF.Text + ', '
        }

        //B- Cadastra o volume para determinar as datas
        execAPIs.URL := FrmMain.BaseURL + 'carga/nova_carga';
        execAPIs.Command := httpPOST;
        execAPIs.Headers.Clear;
        execAPIs.Headers.AddPair('Content-Type','application/json');
        execAPIs.Headers.AddPair('Accept','application/json, text/plain, */*');
        execAPIs.PostData := '{'
        + '"iduser": 47, '
        + '"idpess": "606"'
        + '}';
        execAPIs.Execute();

        //Mostra dados a serem imputados
        nRESP.Lines.Add('carga/nova_carga {'
        + '"iduser": 47, '
        + '"idpess": "606"'
        + '}');

    end;

    exit;

    xProdOLD:= '';

    zLinhas   := 0;
    zContPROD := 0;
    for zLinhas := 0 to nARQ.Lines.Count-1 do
    begin

        //Se envontrar '^MCY' então não é etiqueta de Produtos
        //Blocos de Produtos
        if pos('^MCY', nARQ.Lines[zLinhas]) > 0 then
        begin
            //nRESP.Lines.Add('Este é um arquivo de volume e não de Produtos !');
            MessageDlg('Este é um arquivo de volume e não de Produtos !', mtError, [mbOK]);
            //MessageDlg('Usuário e senha são exigidos !', mtError, []);
            exit;
        end;

        //Blocos de Produtos
        if pos('CI28', nARQ.Lines[zLinhas]) > 0 then
        begin
            inc(zCont);   //Contador de Produto
            //nCont.Caption:= htmARQ.Lines[zLinhas];
            zCampos:= 0;

            xDesenho  := '';
            xProd     := '';
            xDesenho  := '';
            xDESCR    := '';
        end;

        //Campos de Produtos
        xFDstart:= pos('^FD', nARQ.Lines[zLinhas]);
        if xFDstart > 0 then
        begin
            inc(zCampos);   //Inclusão de campos

            //nCont.Caption:= htmARQ.Lines[zLinhas];
            xFDend:= 0;
            xFDend:= pos('^FS', nARQ.Lines[zLinhas]);
            if xFDend > 0 then
            begin
            //Está na mesma linha

              if xFDend >= xFDstart then
              begin

                  if xFDend > 0 then
                  begin
                      case zCampos of
                        1: begin
                        //Produto
                            inc(zContPROD);
                            xProd:= Copy(nARQ.Lines[zLinhas], xFDstart + 3, xFDend - xFDstart - 3);
                        end;
                        4: begin
                        //Descrição
                            xDESCR:= Copy(nARQ.Lines[zLinhas], xFDstart + 3, xFDend - xFDstart - 3);
                        end;
                        7: begin
                        //Desenho
                            xDesenho:= Copy(nARQ.Lines[zLinhas], xFDstart + 3, xFDend - xFDstart - 3);
                        end;
                      end;
                  end else begin
                  //Desenho (Não tem ^Fs no final)
                      if zCampos = 7 then
                      begin
                          xDesenho:= Copy(nARQ.Lines[zLinhas], xFDstart + 3, 100);
                      end;
                  end;
              end;

            end else begin
            //Não está na mesma linha
                //Desenho (Não tem ^Fs no final)
                xDesenho:= Copy(nARQ.Lines[zLinhas], xFDstart + 3, 100);
            end;

            if zCampos = 7 then
            begin

                if xProdOLD <> xProd then
                begin
                    xProdOLD  := xProd;
                    zContPROD := 1;
                end;

                //Mostra dados a serem imputados
                nRESP.Lines.Add('{'
                + '"idmain": ' + IntToStr(zContPROD) + ', '
                + '"produto": "' + xProd + '", '
                + '"desenho": "' + xDesenho + '", '
                + '"descr": "' + xDESCR + '", '
                + '"und": "Und", '
                + '"iduser": 47 '
                + '}');



//                //Cadastra os Produtos
//                execAPIs.URL := FrmMain.BaseURL + 'produtos/novo_produto';
//                execAPIs.Command := httpPOST;
//                execAPIs.Headers.Clear;
//                execAPIs.Headers.AddPair('Content-Type','application/json');
//                execAPIs.Headers.AddPair('Accept','application/json, text/plain, */*');
//                execAPIs.PostData := '{'
//                + '"produto": "' + xProd + '", '
//                + '"desenho": "' + xDesenho + '", '
//                + '"descr": "' + xDESCR + '", '
//                + '"und": "Und", '
//                + '"iduser": 47 '
//                + '}';
//                execAPIs.Execute();
            end;

        end;

    end;

    nCont.Caption:= IntToStr(zCont);
    //nProds.Caption:= IntToStr(zCampos);

end;

procedure TReadFILES.LoadFile;
var
  ext: string;
begin
  if Assigned(WebFilePicker1.Files[0]) then
  begin
    fl := True;
    WebFilePicker1.Files[0].GetFileAsText;
    FFileName := WebFilePicker1.Files[0].Name;
    ext := ExtractFileExt(FFileName);
    //SetSyntaxMemoMode(ext);
  end;
end;

procedure TReadFILES.nARQDblClick(Sender: TObject);
begin
    nRESP.Visible:= not nRESP.Visible;
end;

procedure TReadFILES.UnMarkClick(Sender: TObject);

    procedure Afterdialog(Value: TModalResult);
    var
    xInicio, xCards, xFim: string;
    begin

          if Value = mrYes then
          begin

              //Cabeçalho do HTML
              //upProdutos.URL := 'produtos/zidmain?idmain=0';
              execAPIs.URL := FrmMain.BaseURL + 'produtos/zidmain?idmain=0';
              execAPIs.Command := httpPOST;
              execAPIs.Headers.Clear;
              execAPIs.Headers.AddPair('Content-Type','application/json');
              execAPIs.Headers.AddPair('Accept','application/json, text/plain, */*');
              execAPIs.PostData := '{"idmain": 0}';
              execAPIs.Execute();

          end;

    end;

begin
  Msg01.ShowDialog('Deseja desmarcar todas as etiquetas ?', mtConfirmation, [mbYes, mbNo], @AfterDialog);
end;

procedure TReadFILES.WebFilePicker1Change(Sender: TObject);
begin
    nCont.Caption := '';
    nRESP.Text    := '';
    nARQ.Text   := '';
    //nRESP.Text    := '';

    LoadFile;
end;

procedure TReadFILES.WebFilePicker1GetFileAsText(Sender: TObject;
  AFileIndex: Integer; AText: string);
begin
    //WebSyntaxMemo1.Text := AText;
    nARQ.Text := AText;
end;

procedure TReadFILES.WebFormUnload(Sender: TObject);
begin
  fr.Free;
end;

procedure TReadFILES.WebPanel1DblClick(Sender: TObject);
begin
    //nRESP.Text    := '';
    nRESP.Visible:= not nRESP.Visible;
end;

procedure TReadFILES.WebSyntaxMemo1DragDrop(Sender, Source: TObject; X,
  Y: Integer);
var
  f: TJSHTMLFile;
begin
  f := TJSDragEvent(TDragSourceObject(Source).Event).dataTransfer.files[0];
  if Assigned(f) then
    fr.readAsBinaryString(f);

end;

end.
